"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../../lib");

var _context = _interopRequireDefault(require("./context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormField =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FormField, _PureComponent);

  function FormField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FormField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "validateRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "getSelectorValue", function (value) {
      var _this$props = _this.props,
          selector = _this$props.selector,
          name = _this$props.name;

      if ((0, _lib.isFunc)(selector)) {
        return (0, _lib.getSelectorValue)(value, selector);
      }

      if (name && (0, _lib.objHasOwnProperty)(value, name)) {
        return value[name];
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, _ref) {
      var value = _ref.value,
          checked = _ref.checked;
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          name = _this$props2.name;
      var contextOnChange = _this.context.onChange;

      if (contextOnChange) {
        contextOnChange(e, {
          name: name,
          value: value,
          checked: checked
        });
      }

      if (onChange) {
        onChange(e, {
          name: name,
          value: value,
          checked: checked
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnValidate", function (result) {
      var onValidate = _this.props.onValidate;
      var contextOnValidate = _this.context.onValidate;

      if (contextOnValidate) {
        contextOnValidate(result);
      }

      if (onValidate) {
        onValidate(result);
      }
    });

    return _this;
  }

  _createClass(FormField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          name = _this$props3.name,
          required = _this$props3.required,
          validate = _this$props3.validate,
          excludedOnSubmit = _this$props3.excludedOnSubmit;
      var _this$context = this.context,
          addRef = _this$context.addRef,
          addRequired = _this$context.addRequired,
          addExcluded = _this$context.addExcluded;

      if (name) {
        if (validate) addRef(name, this.validateRef);
        if (required) addRequired(name);
        if (excludedOnSubmit) addExcluded(name);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
          name = _this$props4.name,
          required = _this$props4.required;
      var _this$context2 = this.context,
          addRequired = _this$context2.addRequired,
          removeRequired = _this$context2.removeRequired;

      if (required !== prevProps.required) {
        if (required) {
          addRequired(name);
        } else {
          removeRequired(name);
        }
      }

      if (name !== prevProps.name) {
        removeRequired(prevProps.name);
        addRequired(name);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var name = this.props.name;
      var _this$context3 = this.context,
          removeRef = _this$context3.removeRef,
          removeRequired = _this$context3.removeRequired,
          removeExcluded = _this$context3.removeExcluded;

      if (name) {
        removeRef(name);
        removeRequired(name);
        removeExcluded(name);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          name = _this$props5.name,
          required = _this$props5.required,
          validate = _this$props5.validate,
          excludedOnSubmit = _this$props5.excludedOnSubmit,
          selector = _this$props5.selector,
          onValidate = _this$props5.onValidate,
          onChange = _this$props5.onChange,
          propsRest = _objectWithoutProperties(_this$props5, ["children", "name", "required", "validate", "excludedOnSubmit", "selector", "onValidate", "onChange"]);

      var _this$context4 = this.context,
          data = _this$context4.data,
          contextValidations = _this$context4.validations,
          refs = _this$context4.refs,
          addRef = _this$context4.addRef,
          removeRef = _this$context4.removeRef,
          rest = _objectWithoutProperties(_this$context4, ["data", "validations", "refs", "addRef", "removeRef"]);

      var value = this.getSelectorValue(data);
      var validations = this.getSelectorValue(contextValidations);
      return (0, _lib.getRenderProps)(children, _objectSpread({}, rest, {
        name: name,
        value: value,
        validations: validations,
        data: data,
        onChange: this.handleOnChange,
        onValidate: this.handleOnValidate,
        validateRef: this.validateRef
      }), propsRest);
    }
  }]);

  return FormField;
}(_react.PureComponent);

exports.default = FormField;

_defineProperty(FormField, "contextType", _context.default);

_defineProperty(FormField, "displayName", 'FormField');

_defineProperty(FormField, "propTypes", {
  name: _propTypes.default.string,
  selector: _propTypes.default.func,
  children: _propTypes.default.func.isRequired,
  required: _propTypes.default.bool,
  validate: _propTypes.default.bool,
  excludedOnSubmit: _propTypes.default.bool,
  onValidate: _propTypes.default.func,
  onChange: _propTypes.default.func
});

_defineProperty(FormField, "defaultProps", {
  name: null,
  selector: null,
  required: false,
  validate: true,
  excludedOnSubmit: false,
  onValidate: null,
  onChange: null
});